import { render } from "./InviteMember.vue?vue&type=template&id=51e4e4ee"
import script from "./InviteMember.vue?vue&type=script&lang=js"
export * from "./InviteMember.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__